import React, { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';

export default function HeaderDots() {
  const location = useLocation();

  return (
    <Fragment>
      <div className="header-dots">
        <Link to="/dashboard">
          <div className="icon-wrapper icon-wrapper-alt rounded-circle">
            <div
              className={classnames(
                'icon-wrapper-bg bg-primary',
                { 'opacity-3': location.pathname === '/dashboard', }
              )}
            />
            <FontAwesomeIcon icon={faHome} size="1x" />
          </div>
        </Link>
      </div>
    </Fragment>
  );
}
